import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { Typography, Container, Grid, makeStyles, Divider, Collapse } from '@material-ui/core';
import ProtocolsTable from './protocols_table';
import { BackButton, DefaultButton, PreviewButton, PrintButton, ShowFiltersButton } from '../ui_components/common_buttons';
import history from '../../services/history';
import { updateProtocolsPagination, getProtocols, printProtocols } from '../../store/actions/protocols/protocols_action';
import AutocompleteField from '../ui_components/autocomplete';
import { API_ROUTES } from '../../constants/api_routes';
import { isValid } from 'date-fns';
import DatePicker from '../ui_components/date_picker';

const useStyles = makeStyles((theme) => ({
    container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    nav_container: {
        justifyContent: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    }
}));

const Protocols = ({ protocols }) => {
    const { container, typography, nav_container } = useStyles();
    const dispatch = useDispatch();

    const { page, rowsPerPage, filters } = protocols;

    const goBack = () => {
        history.goBack();
    }

    const getPrintContent = () => dispatch(printProtocols({ page, rowsPerPage, filters }));
    const getPreviewContent = () => dispatch(printProtocols({ page, rowsPerPage, filters }));

    const handleShowFilters = () => {
        dispatch(updateProtocolsPagination({ page, rowsPerPage, filters: { ...filters, showFilters: !filters.showFilters }}));
    }

    const handleCustomerObject = (object) => {
        dispatch(updateProtocolsPagination({ ...protocols, filters: { ...filters, customer: object }}))
    }

    const handleStartDateChange = (object) => {
        if (isValid(object)) {
            dispatch(updateProtocolsPagination({ ...protocols, filters: { ...filters, startDate: new Date(object) }}));
        }
    }

    const handleEndDateChange = (object) => {
        if (isValid(object)) {
            dispatch(updateProtocolsPagination({ ...protocols, filters: { ...filters, endDate: new Date(object) }}));
        }
    }

    const handleFilterButtonClick = () => {
        if (page != 0) {
            return updateProtocolsPagination({ ...protocols, page: 0 });
        }
        dispatch(getProtocols({ page, rowsPerPage, filters }));
    }

    return (
        <Container className={container} maxWidth="xl">
            <Typography align="center" variant="h4" className={typography}>Protokoli</Typography>
            <Grid container className={nav_container} spacing={1}>
                <Grid item>
                    <BackButton handleClick={goBack} />
                </Grid>
                <Grid item>
                    <PrintButton getPrintContent={getPrintContent} />
                </Grid>
                <Grid item>
                    <PreviewButton getPreviewContent={getPreviewContent} />
                </Grid>
                <Grid item>
                    <ShowFiltersButton shown={filters.showFilters} handleClick={handleShowFilters} />
                </Grid>
            </Grid>
            <Divider />
            <Collapse in={filters.showFilters}>
                <Grid container justify="center" spacing={1}>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={8} md={8}>
                            <AutocompleteField
                                name="customer"
                                label="Klijent"
                                placeholder="Klijent"
                                api={API_ROUTES.CUSTOMERS}
                                handleObject={handleCustomerObject}
                                preloadValue={filters.customer}
                            />
                        </Grid>
                    </Grid>
                    <Grid container justify="center" spacing={3}>
                    <Grid item xs={8} md={4}>
                            <DatePicker
                                name="startDate"
                                label="Od"
                                placeholder="Od"
                                fullWidth
                                value={filters.startDate}
                                onChange={handleStartDateChange}
                            />
                        </Grid>
                        <Grid item xs={8} md={4}>
                            <DatePicker
                                name="endDate"
                                label="Do"
                                placeholder="Do"
                                fullWidth
                                value={filters.endDate}
                                onChange={handleEndDateChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item justify="center" xs={8}>
                        <DefaultButton label="Filtriraj" handleClick={handleFilterButtonClick} />
                    </Grid>
            </Grid>
            </Collapse>
            <ProtocolsTable />
        </Container>
    )

};

Protocols.propTypes = {
    protocols: PropTypes.object
}

const mapStateToProps = (state) => ({
    protocols: state.protocols
});

export default connect(mapStateToProps)(Protocols);
